import React, { Component } from "react";
import "antd/dist/antd.css";
import { Form, Button } from "antd";
import { Row, Col } from "antd";
import Uploaded from "../../Images/uploaded.png";
import Uploadlisting from "../../Images/uploadlisting.png";
import CustomerRegProductList from "../../Components/Products/CustomerRegProductList";
import { list, update } from "../../api/Apis";
import AppConfigs from "../../Config/AppConfig";
import { Storage } from "aws-amplify";

class customerProducts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      List: [],
      MasterChecked: false,
      onItemCheck: false,
      rowSelection: [],
      selectedProducts: [],
      loading: false,
      dataLoadingStatus: true,
      selectedRowKeys: [],
      categories: [],
      palletizedProductsData: [],
      bulkGravelCategoryId: ""
    };
  }

  componentDidMount = () => {
    let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
    if (!orgDetails["customerDocuments"]) {
      this.props.history.push("/app/customerdocumentation");
    } else if (!orgDetails["customerLocations"]) {
      this.props.history.push("/app/customerlocations");
    } else if (!orgDetails["productsSelected"]) {
      this.getProducts();
    } else if (!orgDetails["isActive"]) {
      // this.props.history.push('/app/stones');
      this.props.history.push("/carrier_app/review");
    }
  };

  getProducts = () => {
    let query = {
      dataType: "category",
      recordStatus: true,
    };
    list(AppConfigs["entityNames"]["masterData"], query).then((result) => {
      if (result.success) {
          this.setState({
            categories: result.data,
          });
          list(AppConfigs["entityNames"]["products"], {"isActive":true}).then((productsRes) => {
            if (result.success) {
              let categoryData = result.data.filter((c) => c.name === "Bulk Gravel");
              let productsData = productsRes.data.filter((item) => !item["linkId"] && item.productCategory === categoryData[0]["id"]);
              let palletizedProductsData = productsRes.data.filter((item) => !item["linkId"] && item.productCategory !== categoryData[0]["id"]).map((p) => {return p["id"]});
              let productLen = 0;
              this.setState({
                palletizedProductsData,
                bulkGravelCategoryId: categoryData[0]["id"]
              })
              productsData.map(async (product, index) => {
                productLen += 1;
                product["image"] = await Storage.get(product["sizes"][0]["sizeUploadImg"]);
                if (productsData.length === productLen) {
                  this.setState({
                    List: productsData,
                    dataLoadingStatus: false,
                  });
                }
              });
              if (productsData.length === 0) {
                this.setState({
                  dataLoadingStatus: false,
                });
              }
            } else {
              console.log(productsRes.errors);
              this.setState({
                dataLoadingStatus: false,
              });
            }
          });
        }
    });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    if (this.state.selectedProducts.length === 0) {
      alert("Please select products!");
      return;
    }
    this.setState({
      loading: true,
    });
    let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
    let userDetails = JSON.parse(localStorage.getItem("userDetails"));
    let allProducts = [...this.state.palletizedProductsData, ...this.state.selectedProducts[0]];
    let data = {
      entityData: {
        customerProducts: allProducts,
        firstName: userDetails["firstName"],
        productsSelected: true,
        bulkGravelCategoryId: this.state.bulkGravelCategoryId
      },
    };
    update(AppConfigs["assignProductsApi"], orgDetails["id"], data).then(
      (result) => {
        if (result.success) {
          localStorage.setItem("orgDetails", JSON.stringify(result.data.data));
          this.props.history.push("/carrier_app/review");
        } else {
          console.log(result.errors);
        }
      }
    );
  };

  // onItemCheck = (event, data) => {
  //   console.log(event, data);
  //   let selectedProducts = this.state.selectedProducts;
  //   if (event.target.checked) {
  //     selectedProducts.push(data);
  //   } else {
  //     selectedProducts.splice(selectedProducts.indexOf(data), 1);
  //   }
  //   this.setState({
  //     selectedProducts,
  //     selectedRowKeys: data,
  //   });
  // };

  onSelectChange = (data) => {
    console.log(data);
    let selectedProducts = this.state.selectedProducts;
    if (data.length > 1) {
      selectedProducts.splice(selectedProducts.indexOf(data), 1);
      selectedProducts.push(data);
    } else {
      selectedProducts.push(data);
    }
    this.setState({ selectedRowKeys: data });
  };
  render() {
    const { selectedRowKeys } = this.state;

    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };
    return (
      <div className="content-outer">
        <div className="Docdiv">
          <Row type="flex" justify="start">
            <Col span={6} className="DocumentsCol">
              <div className="DocumentDivUnselect">
                <img src={Uploaded} className="Circle" alt="Upload icon" />
                <h3>Documents</h3>
              </div>
              <div className="DocumentDivUnselect">
                <img src={Uploaded} className="Circle" alt="Upload icon" />
                <h3>Locations</h3>
              </div>
              <div className="DocumentDivSelect">
                <img src={Uploadlisting} className="Circle" alt="Upload icon" />
                <h3>Products</h3>
              </div>
            </Col>
            <Col
              span={17}
              style={{
                backgroundColor: "white",
                minHeight: "400px",
                borderRadius: "10px",
                padding: "40px",
              }}
            >
              <Form onSubmit={this.handleSubmit}>
                <div>
                  <Row>
                    <Col span={2} style={{ marginLeft: "10px" }}>
                      <h1>Products</h1>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      lg={24}
                      md={24}
                      sm={24}
                      xs={24}
                      style={{ marginTop: "2%" }}
                    >
                      <CustomerRegProductList
                        data={this.state.List}
                        dataLoadingStatus={this.state.dataLoadingStatus}
                        // rowSelection={
                        //   this.props.rowSelection
                        //     ? Object.assign({}, this.props.rowSelection)
                        //     : undefined
                        // }
                        rowSelection={rowSelection}
                        // onItemCheck={(event, row) =>
                        //   this.onItemCheck(event, row)
                        // }
                        // onChange={(event, item) => this.onChange(event, item)}
                        pagination={{ pagination: false }}
                      />
                    </Col>
                  </Row>
                </div>
                <Row style={{ margin: "90px" }}>
                  <Form.Item style={{ textAlign: "center" }}>
                    <Button
                      type="primary"
                      htmlType="submit"
                      loading={this.state.loading}
                      className="truckSubmit"
                    >
                      Submit
                    </Button>
                  </Form.Item>
                </Row>
              </Form>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}
export default Form.create({ name: "customerProducts" })(customerProducts);
